export default __webpack_public_path__ + "native-android@2x.png";